import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';

import { CdwStepComponent } from './cdw-step/cdw-step.component';
import { CdwStepperComponent } from './cdw-stepper/cdw-stepper.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule, CdwIconModule],
  declarations: [CdwStepperComponent, CdwStepComponent],
  exports: [CdwStepperComponent, CdwStepComponent],
})
export class CdwStepperModule {}
